/** @format */

import template from './gb-item-label.html';
import './gb-item-label.scss';

export const GbItemLabelComponent = {
    template,
    bindings: {
        item: '<',
    },
    controller: class GbItemLabelComponent {
        constructor() {
            'ngInject';
        }
    },
};
